import { ProcessType, Roles } from '@/Domain/enum';
import { RouteConfig } from 'vue-router';
const lazy = (path: string) => () => import(`@/Views/${path}.vue`);

const Layout = lazy('Layout');
const BOEPList = lazy('BOEP/BOEPList');
const BOEPEdit = lazy('BOEP/BOEPEdit');
const ProcessList = lazy('Process/ProcessList');
const ProcessEdit = lazy('Process/ProcessEdit');
const ListManagementList = lazy('ListManagement/ListManagementList');
const ListManagementEdit = lazy('ListManagement/ListManagementEdit');
const RatingsList = lazy('Rating/RatingsList');
const RatingsEdit = lazy('Rating/RatingsEdit');
const ScalingEdit = lazy('Rating/ScalingEdit');
const ExamsEdit = lazy('Rating/ExamsEdit');
const RankingEdit = lazy('Rating/RankingEdit');
const ReplacementList = lazy('Replacement/ReplacementList');
const ReplacementEdit = lazy('Replacement/ReplacementEdit');
const ReplacementStatusContract = lazy('Replacement/ReplacementStatusContract');
const ListReplacementList = lazy('Replacement/ListReplacementList');
const ListReplacementProvisional = lazy('Replacement/ListReplacementProvisional');
const ShippingHistoryList = lazy('Replacement/ShippingHistoryList');
const ShippingHistoryReceivers = lazy('Replacement/ShippingHistoryReceivers');
const CourtList = lazy('Court/CourtList');
const CourtEdit = lazy('Court/CourtEdit');
const LegalTexts = lazy('LegalTexts/LegalTexts');
const LegalWarning = lazy('LegalWarning/LegalWarning');
const CookiesPolicy = lazy('CookiesPolicy/CookiesPolicy');
const PrivacyPolicy = lazy('PrivacyPolicy/PrivacyPolicy');
const AccessDenied = lazy('AccessDenied/AccessDenied');
const Error404 = lazy('Error404/Error404');
const Dashboard = lazy('Dashboard/Dashboard');
const ProcessConfiguration = lazy('ProcessConfiguration/ProcessConfiguration');
const InscriptionEdit = lazy('Inscription/InscriptionEdit');
const ReplacementMerge = lazy('ReplacementMerge/ReplacementMerge');
const NewsChangelog = lazy('NewsChangelog/NewsChangelog');
const LinkedinCallback = lazy('LinkedinCallback/LinkedinCallback');

export const routes = [
    {
      path: '/',
      name: 'Layout',
      component: Layout,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: {
            fullWidth: true,
            areAllRolesAllowed: false,
            role: [Roles.ADMIN]
          }
        },
        {
          path: 'BOEP',
          name: 'BOEP',
          redirect: { name: 'BOEPList' },
          component: {
            template: '<router-view/>'
          },
          children: [
            {
              path: 'all',
              name: 'BOEPList',
              component: BOEPList,
              meta: {
                fullWidth: true,
                areAllRolesAllowed: false,
                role: [Roles.ADMIN]
              }
            },
            {
              path: 'new',
              name: 'BOEPNew',
              component: BOEPEdit,
              meta: {
                areAllRolesAllowed: false,
                role: [Roles.ADMIN]
              }
            },
            {
              path: ':id/edit',
              name: 'BOEPEdit',
              component: BOEPEdit,
              meta: {
                areAllRolesAllowed: false,
                role: [Roles.ADMIN]
              }
            }
          ]
        },
        {
          path: 'process',
          name: 'Process',
          redirect: { name: 'ProcessList' },
          component: {
            template: '<router-view/>'
          },
          children: [
            {
              path: 'all',
              name: 'ProcessList',
              component: ProcessList,
              meta: {
                fullWidth: true,
                areAllRolesAllowed: false,
                role: [Roles.ADMIN]
              }
            },
            {
              path: 'new/:type',
              name: 'CallNew',
              component: ProcessEdit,
              meta: {
                // type: ProcessType.enum.CALL,
                areAllRolesAllowed: false,
                role: [Roles.ADMIN]
              }
            },
            {
              path: ':id/edit/:type',
              name: 'CallEdit',
              component: ProcessEdit,
              meta: {
                // type: ProcessType.enum.CALL,
                areAllRolesAllowed: false,
                role: [Roles.ADMIN]
              }
            },
            {
              path: 'new/:type',
              name: 'BagNew',
              component: ProcessEdit,
              meta: {
                // type: ProcessType.enum.BAG,
                areAllRolesAllowed: false,
                role: [Roles.ADMIN]
              }
            },
            {
              path: ':id/edit/:type',
              name: 'BagEdit',
              component: ProcessEdit,
              meta: {
                // type: ProcessType.enum.BAG,
                areAllRolesAllowed: false,
                role: [Roles.ADMIN]
              }
            },
            {
              path: 'new/:type',
              name: 'PostProvisionNew',
              component: ProcessEdit,
              meta: {
                // type: ProcessType.enum.POSTPROVISION,
                areAllRolesAllowed: false,
                role: [Roles.ADMIN]
              }
            },
            {
              path: ':id/edit/:type',
              name: 'PostProvisionEdit',
              component: ProcessEdit,
              meta: {
                // type: ProcessType.enum.POSTPROVISION,
                areAllRolesAllowed: false,
                role: [Roles.ADMIN]
              }
            }
          ]
        },
        {
          path: 'listManagement',
          name: 'ListManagement',
          redirect: { name: 'ListManagementList' },
          component: {
            template: '<router-view/>'
          },
          children: [
            {
              path: 'all',
              name: 'ListManagementList',
              component: ListManagementList,
              meta: {
                fullWidth: true,
                areAllRolesAllowed: false,
                role: [Roles.ADMIN]
              }
            },
            {
              path: ':id/inscriptions',
              name: 'ListManagementEdit',
              component: ListManagementEdit,
              meta: {
                fullWidth: true,
                areAllRolesAllowed: false,
                role: [Roles.ADMIN]
              }
            },
            {
              path: ':id/inscriptionEdit/:inscriptionId',
              name: 'InscriptionEdit',
              component: InscriptionEdit,
              meta: {
                areAllRolesAllowed: true
              }
            }
          ]
        },
        {
          path: 'ratings',
          name: 'ratings',
          redirect: { name: 'RatingsList' },
          component: {
            template: '<router-view/>'
          },
          children: [
            {
              path: 'all',
              name: 'RatingsList',
              component: RatingsList,
              meta: {
                fullWidth: true,
                areAllRolesAllowed: true
              }
            },
            {
              path: 'RatingsEdit/:tabActive/:id',
              name: 'RatingsEdit',
              component: RatingsEdit,
              meta: {
                fullWidth: true,
                areAllRolesAllowed: true
              },
              children: [
                {
                  path: 'exams',
                  name: 'ExamsEdit',
                  component: ExamsEdit,
                  meta: {
                    fullWidth: true,
                    areAllRolesAllowed: true
                  }
                },
                {
                  path: 'scaling',
                  name: 'ScalingEdit',
                  component: ScalingEdit,
                  meta: {
                    fullWidth: true,
                    areAllRolesAllowed: true
                  }
                },
                {
                  path: 'ranking',
                  name: 'RankingEdit',
                  component: RankingEdit,
                  meta: {
                    fullWidth: true,
                    areAllRolesAllowed: true
                  }
                }
              ]
            }
          ]
        },
        {
          path: 'replacement',
          name: 'replacement',
          redirect: { name: 'ReplacementList' },
          component: {
            template: '<router-view/>'
          },
          children: [
            {
              path: 'all',
              name: 'ReplacementList',
              component: ReplacementList,
              meta: {
                fullWidth: true,
                areAllRolesAllowed: false,
                role: [Roles.ADMIN]
              }
            },
            {
              path: 'new',
              name: 'ReplacementNew',
              component: ReplacementEdit,
              meta: {
                fullWidth: true,
                areAllRolesAllowed: false,
                role: [Roles.ADMIN]
              }
            },
            {
              path: ':id/edit',
              name: 'ReplacementListEdit',
              component: ReplacementEdit,
              meta: {
                fullWidth: true,
                areAllRolesAllowed: false,
                role: [Roles.ADMIN]
              }
            },
            {
              path: ':replacementId/list',
              name: 'ListReplacementList',
              component: ListReplacementList,
              meta: {
                fullWidth: true,
                areAllRolesAllowed: false,
                role: [Roles.ADMIN]
              }
            },
            {
              path: 'provisional',
              name: 'ListReplacementProvisional',
              component: ListReplacementProvisional,
              meta: {
                fullWidth: true,
                areAllRolesAllowed: false,
                role: [Roles.ADMIN]
              }
            },
            {
              path: ':id/replacementInfo/:replacementListCandidateId/:fromShippingHistory?',
              name: 'ReplacementStatusContract',
              component: ReplacementStatusContract,
              meta: {
                fullWidth: true,
                areAllRolesAllowed: false,
                role: [Roles.ADMIN]
              }
            },
            {
              path: ':id/shippingHistory/all',
              name: 'ShippingHistoryList',
              component: ShippingHistoryList,
              meta: {
                fullWidth: true,
                areAllRolesAllowed: false,
                role: [Roles.ADMIN]
              }
            },
            {
              path: ':id/shippingHistory/:shippingHistoryId/receiversList',
              name: 'ShippingHistoryReceivers',
              component: ShippingHistoryReceivers,
              meta: {
                fullWidth: true,
                areAllRolesAllowed: false,
                role: [Roles.ADMIN]
              }
            },
            {
              path: 'merge',
              name: 'ReplacementMerge',
              component: ReplacementMerge,
              meta: {
                fullWidth: true,
                areAllRolesAllowed: false,
                role: [Roles.ADMIN]
              } 
            },
            {
              path: 'merge/:id/edit',
              name: 'ReplacementMergeEdit',
              component: ReplacementMerge,
              meta: {
                fullWidth: true,
                areAllRolesAllowed: false,
                role: [Roles.ADMIN]
              } 
            }
          ]
        },
        {
          path: 'legalTexts',
          name: 'legalTexts',
          redirect: { name: 'LegalTexts' },
          component: {
            template: '<router-view/>'
          },
          children: [
            {
              path: 'definition',
              name: 'LegalTexts',
              component: LegalTexts,
              meta: {
                fullWidth: true,
                areAllRolesAllowed: false,
                role: [Roles.ADMIN]
              }
            }
          ]
        },
        {
          path: 'processConfiguration',
          name: 'processConfiguration',
          redirect: { name: 'ProcessConfiguration' },
          component: {
            template: '<router-view/>'
          },
          children: [
            {
              path: 'definition',
              name: 'ProcessConfiguration',
              component: ProcessConfiguration,
              meta: {
                fullWidth: true,
                areAllRolesAllowed: false,
                role: [Roles.ADMIN]
              }
            }
          ]
        },
        {
          path: 'Court',
          name: 'Court',
          redirect: { name: 'CourtList' },
          component: {
            template: '<router-view/>'
          },
          children: [
            {
              path: 'all',
              name: 'CourtList',
              component: CourtList,
              meta: {
                fullWidth: true,
                areAllRolesAllowed: false,
                role: [Roles.ADMIN]
              }
            },
            {
              path: 'new',
              name: 'CourtNew',
              component: CourtEdit,
              meta: {
                fullWidth: true,
                areAllRolesAllowed: false,
                role: [Roles.ADMIN]
              }
            },
            {
              path: ':email/edit',
              name: 'CourtEdit',
              component: CourtEdit,
              meta: {
                fullWidth: true,
                areAllRolesAllowed: false,
                role: [Roles.ADMIN]
              }
            }
          ]
        },
        {
          path: '/accessdenied',
          name: 'AccessDenied',
          component: AccessDenied,
          meta: {
            areAllRolesAllowed: true
          }
        },
        {
          path: '/legalwarning',
          name: 'LegalWarning',
          component: LegalWarning,
          meta: {
            areAllRolesAllowed: true
          }
        },
        {
          path: '/cookiesPolicy',
          name: 'CookiesPolicy',
          component: CookiesPolicy,
          meta: {
            areAllRolesAllowed: true
          }
        },
        {
          path: '/privacyPolicy',
          name: 'PrivacyPolicy',
          component: PrivacyPolicy,
          meta: {
            areAllRolesAllowed: true
          }
        },
        {
          path: '/newsChangelog',
          name: 'NewsChangelog',
          component: NewsChangelog,
          meta: {
            fullWidth: true,
            areAllRolesAllowed: true
          }
        },
        {
          path: '/linkedin/callback',
          name: 'LinkedinCallback',
          component: LinkedinCallback,
          meta: {
            fullWidth: true,
            areAllRolesAllowed: true
          }
        }
      ]
    },
    {
      path: '*',
      name: 'Default',
      redirect: { name: 'Error404' },
      component: Layout,
      children: [{
        path: 'Error404',
        name: 'Error404',
        component: Error404,
        meta: {
          fullWidth: true,
          areAllRolesAllowed: true
        }
      }]

    }
] as RouteConfig[];
